<p-scrollPanel [style]="{height: 'calc(67vh)'}">
  <div class="mat-elevation-z8" *ngIf="productItems.length > 0">
    <table mat-table [dataSource]="productItems">
      <!-- Product Name Column -->
      <ng-container matColumnDef="Name">
        <th mat-header-cell *matHeaderCellDef>Product Name</th>
        <td mat-cell *matCellDef="let row">{{ row.Name }}</td>
      </ng-container>
      <!-- CategoryId Column -->
      <ng-container matColumnDef="CategoryId">
        <th mat-header-cell *matHeaderCellDef>Category</th>
        <td mat-cell *matCellDef="let row">{{ row.ParentCategoryName }}</td>
      </ng-container>
      <!-- SubCategoryId Column -->
      <ng-container matColumnDef="SubCategoryId">
        <th mat-header-cell *matHeaderCellDef>Sub-Category</th>
        <td mat-cell *matCellDef="let row">{{ row.CategoryName }}</td>
      </ng-container>
      <!-- UOM Column -->
      <ng-container matColumnDef="UOM">
        <th mat-header-cell *matHeaderCellDef>UOM</th>
        <td mat-cell *matCellDef="let row">{{ row.UOM }}</td>
      </ng-container>
      <!-- Units Column -->
      <ng-container matColumnDef="Units">
        <th mat-header-cell *matHeaderCellDef>Units</th>
        <td mat-cell *matCellDef="let row">{{ row.UOM }}</td>
      </ng-container>
      <!-- PublishedPrice -->
      <ng-container matColumnDef="PublishedPrice">
        <th mat-header-cell *matHeaderCellDef>Price</th>
        <td mat-cell *matCellDef="let row">{{ row.PublishedPrice }}</td>
      </ng-container>
      
      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns" class="cursor-pointer" (click)="viewProductDetails(row)"></tr>
    </table>
    <mat-paginator
      class="mat-paginator-sticky"
      [pageSizeOptions]="productRowsPerPageOptions"
      [pageSize]="productRowsPerPage"
      [length]="productTotalRecords"
      [pageIndex]="productPageIndex"
      [showFirstLastButtons]="true"
      (page)="handleProductLazyLoadTable($event)"
      aria-label="Select page of products"
    >
    </mat-paginator>
  </div>  
</p-scrollPanel>